
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model} from '../../controlador-detalles';
    import { Recurso } from '@/__env/lib/Cursos/Recursos';
    import { Wait } from '@/__env/ext';
    import { Pregunta } from '@/__env/lib/Cursos/Preguntas';
    import { Curso } from '@/__env/lib/Cursos';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {

        public get Controlador() { return Model; }
        public get Curso(): Curso { return Model.Curso; }


        Cerrar()
        {
            this.Controlador.Cerrar()
        }


    }
